import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { AdSlotIds } from "@/shared/types";
import { useI18n } from "@/shared/hooks";
import { CarouselAd } from "@/ads/components/CarouselAd/CarouselAd";
import { useShowAds } from "@/components/Ads/hooks/useShowAds";
import { SlideDescription } from "../Controls/SlideDescription";
const testId = "cdp-gallery-images-last-image-placeholder";
export const AdsExtraSlide = () => {
    const { t } = useI18n();
    const { isAllSlotsLoaded } = useShowAds();
    const isAdLoaded = isAllSlotsLoaded([AdSlotIds.AD_CAROUSEL]);
    const description = isAdLoaded ? t("gallery.image.ad.description") : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "div", display: "flex", alignItems: "center", justifyContent: "center", testId: testId, id: "last-image-placeholder", children: _jsx(CarouselAd, {}) }), _jsx(SlideDescription, { description: description })] }));
};
